import { render, staticRenderFns } from "./PremiumFeaturesModal.vue?vue&type=template&id=799e2a78&"
import script from "./PremiumFeaturesModal.vue?vue&type=script&lang=js&"
export * from "./PremiumFeaturesModal.vue?vue&type=script&lang=js&"
import style0 from "./PremiumFeaturesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports